const isiPad = (navigator.userAgent.match('iPad')) || (navigator.userAgent.match(/Macintosh/i) && 'ontouchend' in document);
const ua = navigator.userAgent.toLowerCase();
const isAndroidTablet = ua.includes('android') && !ua.includes('mobile');
const isWindowsTablet = ua.includes('windows nt') && !ua.includes('mobile') && window.matchMedia('(pointer: coarse)').matches;


const brandTemplate = {
    checkout: 'checkout-mobile-nav',
    default: 'mobile-nav'
};

if (isiPad || isAndroidTablet || isWindowsTablet) {
    document.querySelector('html').setAttribute('data-device-type', 'tablet');

    let myNewsLink;

    const myNewsConfigs = {
        codesports: {
            label: 'My Code',
            URLPath: '/my-code'
        },
        default: {
            label: 'My News',
            URLPath: '/my-news'
        }
    };

    const getConfigs = (site) => {
        return typeof myNewsConfigs[site] === 'object' ? myNewsConfigs[site] : myNewsConfigs.default;
    };

    // Create the nav link for My News (it's inserted separately for desktop and mobile)
    if (window?.newscorpau?.c3po?.enabled === true) {
        const currentSite = window.newscorpau.site || '';
        const myNewsObj = getConfigs(currentSite);
        const myNewsLabel = myNewsObj.label;
        const myNewsURLPath = myNewsObj.URLPath;

        const liString = `<li class="mobile-navigation_li" data-followedFromDomain="${currentSite}.com.au" followedFromDomain="${currentSite}.com.au" data-container="global-hamburger-menu" data-device="tablet" device="tablet" mynewsLink="${myNewsURLPath}" mynewsLabel="${myNewsLabel}"><a class="mobile-navigation_link" data-tgev="event10" data-tgev-container="global-header" data-tgev-label="my-newsfeed" data-tgev-order="0" data-tgev-metric="npv" href="${myNewsURLPath}">${myNewsLabel}</a></li>`;

        // Creating outer placeholder element then extracting li tag from it.
        // Doing it this way to avoid multiple setAttribute calls.
        const myNewsPlaceholder = document.createElement('ul');
        myNewsPlaceholder.innerHTML = liString;
        myNewsLink = myNewsPlaceholder.querySelector('li');
    }

    // - Changing call to a relative link because beta URLs are causing problems.
    const siteURL = '';
    // let siteURL = `https://www.${newscorpau.site}${newscorpau.environment === 'prod' ? '' : newscorpau.environment}.com.au`;
    // - if (newscorpau.environment === 'local') {
    // -     siteURL = `http://${newscorpau.site}.local`;
    // - }
    const template = brandTemplate[window.newscorpau.brand] || brandTemplate.default;

    fetch(`${siteURL}/spp-api/v1/template/?path=layouts.whitelabel.${template}&render=phug`)
        .then(response => {
            return response.text();
        })
        .then(text => {
            const navCSS = document.createElement('link');
            navCSS.setAttribute('rel', 'stylesheet');
            navCSS.setAttribute('href', `${siteURL}/wp-content/themes/newscorpau-news-dna/dist/stylesheets/css-mobile-nav.css`);
            document.head.appendChild(navCSS);
            const nav = document.createElement('div');
            nav.innerHTML = text;
            // Append My News link to nav for C3PO sites
            if ((window?.newscorpau?.c3po?.enabled === true) && myNewsLink) {
                const homeBtn = nav.querySelector('ul li.mobile-navigation_li.home');
                homeBtn.after(myNewsLink);
            }
            document.body.appendChild(nav);
        })
        .then(() => {
            const hamburger = '<div class="hamburger"><div class="icon-sprite-item" style="width: 16px; height: 16px"><svg><use xlink:href="#hamburger"></use></svg></div><div class="icon-sprite-item" style="width: 16px; height: 16px"><svg><use xlink:href="#cross"></use></svg></div></div>';
            document.querySelector('nav.navigation').innerHTML += hamburger;
            const backdrop = document.createElement('div');
            backdrop.classList.add('backdrop');
            document.body.appendChild(backdrop);
            const navJS = document.createElement('script');
            const cacheKey = window.newscorpau.cache_key;
            const cacheVersion = window.newscorpau.cache_version;
            navJS.setAttribute('src', `${siteURL}/wp-content/themes/newscorpau-news-dna/dist/javascripts/js-navigation-mobile.js?${cacheKey}=${cacheVersion}`);
            document.head.appendChild(navJS);
        });
}
